/* trewrld Cinematic Journal (blog), Sept 2026. Upgrades article body markup in place. No dependencies.
   - Product cards (old inline-styled cards or .tw-buy) become live Buy / Learn more panels (cloned from #cin-shop, rendered by Liquid).
   - .tw-film[data-yt] becomes a poster tile that opens the film lightbox (cinema.js).
   - The FAQ block becomes an accordion.
   - Sticky Buy bar shows after the hero and hides near the shop section. */
(function () {
  'use strict';
  if (window.__trewrldJournal) return; window.__trewrldJournal = true;

  function handleFrom(href) {
    var m = /\/products\/([^/?#"']+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  function upgradeCards(col) {
    var shop = document.getElementById('cin-shop');
    var candidates = col.querySelectorAll('.tw-buy, div[style*="border:1px solid #e0e0e0"], div[style*="border: 1px solid #e0e0e0"]');
    candidates.forEach(function (card) {
      var a = card.querySelector('a[href*="/products/"]');
      var h = card.getAttribute('data-handle') || (a && handleFrom(a.getAttribute('href')));
      if (!h || !shop) return;
      var src = shop.querySelector('.cin-abuy[data-handle="' + h.replace(/"/g, '') + '"]');
      if (!src) return;
      var clone = src.cloneNode(true);
      clone.classList.add('is-in', 'cin-abuy--inline');
      card.replaceWith(clone);
    });
    /* Unwrap old flex wrappers that now only hold Buy panels */
    col.querySelectorAll('div[style*="display:flex"], div[style*="display: flex"]').forEach(function (w) {
      var kids = Array.prototype.slice.call(w.children);
      if (kids.length && kids.every(function (k) { return k.classList.contains('cin-abuy'); })) {
        var frag = document.createDocumentFragment();
        kids.forEach(function (k) { frag.appendChild(k); });
        w.replaceWith(frag);
      }
    });
  }

  function upgradeFilms(col) {
    col.querySelectorAll('.tw-film[data-yt]').forEach(function (el) {
      var id = (el.getAttribute('data-yt') || '').replace(/[^A-Za-z0-9_-]/g, '');
      if (!id) return;
      var title = el.getAttribute('data-title') || 'Watch the film';
      var cap = el.getAttribute('data-caption') || '';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'cin-hl__film';
      b.setAttribute('data-cin-film', id); b.setAttribute('data-cin-title', title);
      b.setAttribute('aria-label', 'Play: ' + title);
      b.innerHTML = '<img src="https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg" alt="" loading="lazy" width="1280" height="720"><span class="cin-hl__play"><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>' + title.replace(/</g, '&lt;') + '</span></span>';
      el.innerHTML = '';
      el.appendChild(b);
      if (cap) { var c = document.createElement('span'); c.className = 'cin-afilm__cap'; c.textContent = cap; el.appendChild(c); }
    });
  }

  function upgradeFaq(col) {
    var heads = col.querySelectorAll('h2, h3');
    var head = null;
    for (var i = 0; i < heads.length; i++) {
      if (/^\s*(faq|faqs|frequently asked)/i.test(heads[i].textContent)) { head = heads[i]; break; }
    }
    if (!head) return;
    var wrap = document.createElement('div'); wrap.className = 'cin-faq';
    var n = head.nextElementSibling, used = [];
    while (n && !/^H2$/.test(n.tagName) && !n.classList.contains('seo-store')) {
      var q = null, ans = null;
      if (n.tagName === 'P' && n.firstElementChild && /^(STRONG|B)$/.test(n.firstElementChild.tagName) && n.textContent.trim().indexOf(n.firstElementChild.textContent.trim()) === 0) {
        var clone = n.cloneNode(true);
        q = clone.firstElementChild.textContent.trim();
        clone.removeChild(clone.firstElementChild);
        while (clone.firstChild && ((clone.firstChild.nodeType === 1 && clone.firstChild.tagName === 'BR') || (clone.firstChild.nodeType === 3 && !clone.firstChild.textContent.trim()))) clone.removeChild(clone.firstChild);
        ans = clone.innerHTML.trim();
        used.push(n);
      } else if (n.tagName === 'H3' && n.nextElementSibling && n.nextElementSibling.tagName === 'P') {
        q = n.textContent.trim(); ans = n.nextElementSibling.innerHTML; used.push(n, n.nextElementSibling);
        n = n.nextElementSibling;
      } else { break; }
      if (q && ans) {
        var d = document.createElement('details');
        var s = document.createElement('summary'); s.textContent = q;
        var body = document.createElement('div'); body.innerHTML = ans;
        d.appendChild(s); d.appendChild(body); wrap.appendChild(d);
      }
      n = n.nextElementSibling;
    }
    if (!wrap.children.length) return;
    if (/^\s*faq\s*$/i.test(head.textContent)) head.textContent = 'Questions, answered.';
    used[0].parentNode.insertBefore(wrap, used[0]);
    used.forEach(function (u) { u.remove(); });
    var first = wrap.querySelector('details'); if (first) first.open = true;
  }

  function initSticky() {
    var bar = document.querySelector('[data-cin-sticky]');
    var hero = document.querySelector('.cin-ahero');
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var pastHero = false, nearShop = false;
    function sync() { bar.classList.toggle('is-on', pastHero && !nearShop); }
    new IntersectionObserver(function (e) { pastHero = !e[0].isIntersecting; sync(); }).observe(hero);
    var shop = document.getElementById('cin-shop');
    if (shop) new IntersectionObserver(function (e) { nearShop = e[0].isIntersecting; sync(); }, { rootMargin: '0px 0px -20% 0px' }).observe(shop);
  }

  function init() {
    var col = document.querySelector('.cin-abody__col');
    if (col) { upgradeCards(col); upgradeFilms(col); upgradeFaq(col); }
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
